import { useReducer } from "react";
import constate from "constate";
import { ApplicationState } from "./ApplicationState";
import { ApplicationAction, UPDATE } from "./ApplicationActions";

// Initial state
const initialState: ApplicationState = {
  globalSearchText: undefined,
  activeMenuRow: { activeMenuItem: 0, activeSubMenuItem: 0 },
  breadcrumb: [],
  reload: false,
  notificationNumber: 0
};

let applicationState = initialState;

// Reducer
const reducer = (
  state: ApplicationState,
  action: ApplicationAction
): ApplicationState => {
  let newState = state;
  switch (action.type) {
    case UPDATE:
      newState = { ...state, ...action.payload };
  }
  applicationState = newState;
  return newState;
};

// Custom hook with state and functions
const useApplicationContextSpec = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setGlobalTextSearch = (searchText: string) => {
    dispatch({
      type: UPDATE,
      payload: {
        globalSearchText: searchText,
      },
    });
  };

  const setActiveMenuRow = (
    activeMenuItem: number,
    activeSubMenuItem: number
  ) => {
    dispatch({
      type: UPDATE,
      payload: {
        activeMenuRow: {
          activeMenuItem: activeMenuItem,
          activeSubMenuItem: activeSubMenuItem,
        },
      },
    });
  };

  const setBreadcrumb = (newBreadcrumb: string[]) => {
    dispatch({
      type: UPDATE,
      payload: {
        breadcrumb: [...newBreadcrumb],
      },
    });
  };

  const setReload = (data: any) => {
    dispatch({
      type: UPDATE,
      payload: {
        reload: data,
      },
    });
  };

  const setNotificationNumber = (numberOfNotification: number) => {
    dispatch({
      type: UPDATE,
      payload: {
        notificationNumber: numberOfNotification,
      },
    });
  };

  return {
    state,
    setGlobalTextSearch,
    setActiveMenuRow,
    setBreadcrumb,
    setReload,
    setNotificationNumber
  };
};

export const getApplicationState = () => applicationState;

// Share your custom hook
export const [ApplicationProvider, useApplicationContext] = constate(
  useApplicationContextSpec
);
